/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React from "react";
import cn from "classnames";
import s from "./Heading.module.css";

export type TagProps = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface IHeading extends React.HTMLProps<HTMLHeadingElement> {
  as: TagProps;
  children: React.ReactNode;
  isBold?: boolean;
  className?: string;
}
const Heading = ({
  as: Tag,
  className,
  children,
  isBold = true,
  ...rest
}: IHeading) => {
  const boldClass = isBold ? "font-bold" : "font-normal";
  return (
    <Tag
      className={cn(className, s.root, s[Tag], boldClass)}
      {...rest}
      test-id="UI06KE6n"
    >
      {children}
    </Tag>
  );
};

export default Heading;
